export default __webpack_public_path__ + "static/core@2x-044a53373683b9e2e7734c415b3140bb.png";